import { Navigate, Route, Routes } from "react-router-dom";
import FullCalendar from "../components/Todo/component/FullCalendar/FullCalendar";
import TodoMap from "../components/Todo/component/Map/TodoMap";
import TodoListMulti from "../components/Todo/component/TodoListMulti/TodoListMulti";
import NotFound from "../page/NotFound";
import DefaultLayoutWrapper from "./DefaultLayoutWrapper";
import Page from "./Page";
import Profile from "../page/Profile";
import Workspace from "../components/Todo/component/Workspace/Workspace";

const AppRouter = () => {
    return (
        <DefaultLayoutWrapper>
            <Routes>
                <Route
                    index
                    path="/"
                    element={<Page render={<Navigate to="/workspace" replace />} />}
                />
                <Route path="/workspace" element={<Page render={<Workspace />} />} />
                <Route path="/todo/:workspaceId?" element={<Page render={<TodoListMulti />} />} />
                <Route path="/todo/:workspaceId/:id" element={<Page render={<TodoListMulti />} />} />
                <Route path="/calendar/:workspaceId?" element={<Page render={<FullCalendar />} />} />
                <Route path="/calendar/:workspaceId/:id" element={<Page render={<FullCalendar />} />} />
                {/* <Route path="/map/:workspaceId?" element={<Page render={<TodoMap />} />} /> */}
                <Route path="/profile" element={<Page render={<Profile />} />} />
                <Route path="*" element={<Page render={<NotFound />} />} />
            </Routes>
        </DefaultLayoutWrapper>
    )
}

export default AppRouter;